// test103
(103 && 0);
